<template>
    <div>
        <PackageHero></PackageHero>
        <AboutSection></AboutSection>
    </div>
</template>
<script>
import PackageHero from "./components/PackageHero";
import Hero from "./components/Hero";
import BasicElements from "./components/BasicElements";
import CustomControls from "./components/CustomControls";
import Navigation from "./components/Navigation";
import JavascriptComponents from "./components/JavascriptComponents";
import Carousel from "./components/Carousel";
import Icons from "./components/Icons";
import Examples from "./components/Examples";
import AboutSection from "./components/AboutSection";



export default {
  name: "homepage",
  components: {
    PackageHero,    
    AboutSection
  }
};
</script>
